import { gql, useMutation } from "@apollo/client";

import { GqlUserCreateInput } from "~/__generated__";

import { USERS_GET_ALL } from "../screens/UserListScreen/api/useUserListScreen_GetAll";

export const USER_CREATE = gql(`
mutation UserCreate($input: GqlUserCreateInput!) {
  userCreate(input: $input) {
    id
    firstName
    lastName
    phone
    email
  }
}
`);

export default function useUserCreate() {
    const [createUser, { data, loading, error }] = useMutation(USER_CREATE, {
        refetchQueries: [USERS_GET_ALL],
    });

    return {
        createUser: (input: GqlUserCreateInput) =>
            createUser({
                variables: {
                    input,
                },
            }),
        loading,
        error,
        data: data?.userCreate,
    };
}
